import React, { useState, useEffect } from 'react'
import { styled } from 'styled-components'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { ErrorMessage } from './Login'

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
`

const PassowrdForm = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background-color: #fff;
`

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  label {
    font-size: 12px;
    color: #808080;
  }
  input {
    width: 100%;
    border: none;
    border-bottom: 1px solid #b3b3b3;
    padding: 4px 0;

    outline: none;
  }

  input::placeholder {
    color: #b3b3b3; /* 플레이스홀더 텍스트의 색상을 빨간색으로 설정 */
  }
`

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 99px;
  padding: 10px 0;
  color: #fff;
  background: #57c9a7;
  cursor: pointer;
  width: 100%;

  &.cancle {
    color: #333;
    background: #e6e6e6;
  }
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`
export default function FindPassword() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('')
  const [status, setStatus] = useState(false)
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  const handlePasswordChange = async () => {
    if (newPassword !== newPasswordConfirm) {
      setStatus(true)
      setMessage('새 비밀번호가 일치하지 않습니다.')
      return
    }

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/auth/change-password`,
        {
          email,
          oldPassword: password,
          newPassword,
        }
      )
      alert('비밀번호가 성공적으로 변경되었습니다.')
      return navigate('/', { replace: true })
    } catch (error) {
      setStatus(true)
      setMessage('비밀번호 변경 실패')
    }
  }

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (status) {
      timer = setTimeout(() => {
        setStatus(false)
        setMessage('')
      }, 3000)
    }
    return () => clearTimeout(timer) // 컴포넌트 언마운트 시 타이머 정리
  }, [status])

  return (
    <Wrapper>
      <PassowrdForm>
        <Title>비밀번호 변경하기</Title>
        <InputWrapper>
          <input
            type="text"
            id="email"
            placeholder="이메일을 입력하세요"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </InputWrapper>
        <InputWrapper>
          <label htmlFor="password">현재 비밀번호</label>
          <input
            type="password"
            id="password"
            placeholder="현재 비밀번호를 입력하세요"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </InputWrapper>
        <InputWrapper>
          <label htmlFor="newPassword">새 비밀번호</label>
          <input
            type="password"
            id="newPassword"
            placeholder="새 비밀번호를 입력하세요"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </InputWrapper>
        <InputWrapper>
          <label htmlFor="newPasswordConfirm">새 비밀번호 확인</label>
          <input
            type="password"
            id="newPasswordConfirm"
            placeholder="새 비밀번호를 확인하세요"
            value={newPasswordConfirm}
            onChange={(e) => setNewPasswordConfirm(e.target.value)}
          />
        </InputWrapper>

        {status && <ErrorMessage>{message}</ErrorMessage>}

        <ButtonWrapper>
          <Button onClick={handlePasswordChange}>확인</Button>
          <Button
            className="cancle"
            onClick={() => navigate('/', { replace: true })}
          >
            취소
          </Button>
        </ButtonWrapper>
      </PassowrdForm>
    </Wrapper>
  )
}
